import './connectPromotionAd.scss';

import { Button, Checkbox, Icon } from '@/components/ui';
import { useEffect, useRef, useState } from 'react';
import { makeRequest } from '@/services/makeRequest';
import showToast from '../../toast/Toast';

import MinBalancePopup from '../minBalance/MinBalancePopup';
import useLadyService from '../../../services/LadyService';
import { Link } from 'react-router-dom';
import { InputInLabel } from '../../ui';
import InputWithArrows from '../../ui/input/inputWithArrows/InputWithArrows';
import { Popup } from '../index';

const ConnectPromotionAdPopup = (props) => {
	const {
		open,
		setOpen,
		position,
		price,
		currentPrice,
		slugProfile,
		setPrice,
		setPosition,
		setPromotion,
		setOpenAll,
		name,
		city_id,
		dynamicTop,
		setProfilesData,
		initialDate,
		placesData
	} = props;

	const { t } = useLadyService();

	const [zeroBalance, setZeroBalance] = useState(false);

	const [isLoading, setIsLoading] = useState(false);

	const openedFromLink = initialDate !== undefined && initialDate !== null;

	const [isLow, setIsLow] = useState(false);
	const [full, setFull] = useState(() => {
		if (openedFromLink) return !initialDate;
		return true;
	});
	const [date, setDate] = useState(() => {
		if (initialDate) {
			return new Date(initialDate);
		} else {
			const tomorrow = new Date();
			tomorrow.setDate(tomorrow.getDate() + 1); // add 1 day
			return tomorrow.toISOString().split('T')[0];
		}
	});

	const [hasChanges, setHasChanges] = useState(false);

	const minPrice = 1;

	const presetPrice = Number(price)

	const [auctionPrice, setAuctionPrice] = useState(presetPrice);

	const [dynamicPosition, setDynamicPosition] = useState(position);

	useEffect(() => {
		if (!placesData || placesData.length === 0) {
			setDynamicPosition(position);
			return;
		}

		const foundIndex = placesData.findIndex((item) => auctionPrice >= item.price);

		if (foundIndex !== -1) {
			setDynamicPosition(foundIndex + 1);
		} else {
			setDynamicPosition(placesData.length);
		}
	}, [auctionPrice, placesData, position]);

	const handleClickUp = () => {
		setAuctionPrice((prev) => prev + 1);
	};

	const handleClickDown = () => {
		if (!!auctionPrice) {
			setAuctionPrice((prev) => prev - 1);
		} else if (auctionPrice <= 1) {
			setAuctionPrice(1);
		}
	};

	useEffect(() => {
		if (openedFromLink) {
			setHasChanges(true);
			return;
		}

		const priceChanged = auctionPrice !== presetPrice;
		const dateChanged = date !== initialDate;
		const fullChanged = true;

		setHasChanges(priceChanged || dateChanged || fullChanged);
	}, [auctionPrice, date, full, initialDate]);

	const onChangeFull = () => {
		setFull((prev) => !prev);
	};

	const onChangeAuction = (e) => {
		const value = e.target.value;
		const numericValue = value.replace(/[^0-9]/g, '');

		setAuctionPrice(Number(numericValue));
	};

	const onChangeDate = (value) => {
		setDate(value);
		if (full) setFull(false);
	};

	const validNew = t('valid')[0].toUpperCase() + t('valid').slice(1);

	const dt_obj = new Date(date);
	const ts_unix = dt_obj.getTime() / 1000;

	const dateRes = full ? null : !!date ? ts_unix : null;

	const onSubmit = (e) => {
		e.preventDefault();
		const fetchData = async () => {
			setIsLoading(true);
			try {
				const route = `places/up/${slugProfile}`;

				const method = 'POST';
				const payload = {
					price: auctionPrice,
					...(dateRes && { expired_at: dateRes }),
				};

				const res = await makeRequest({ route, method, payload });

				if (res.message === 'balance_insufficient') {
					setIsLoading(false);
					setZeroBalance(true);
				} else if (dynamicTop) {
					const route = `user/profiles`;
					const method = 'GET';

					const payload = {
						city: city_id,
						limit: 1000,
					};

					const { profiles } = await makeRequest({
						route,
						method,
						payload,
					});

					setProfilesData((prevData) => {
						const updatedData = [...prevData];

						profiles.forEach((profile) => {
							const index = updatedData.findIndex(
								(item) => item.slug === profile.slug,
							);

							if (index !== -1) {
								updatedData[index] = profile;
							}
						});

						return updatedData;
					});

					setIsLoading(false);
					showToast({
						message: t('activepromo'),
						variant: 'success',
					});

					setOpen(false);
				} else if (!dynamicTop) {
					setPromotion(dateRes);
					setPosition(dynamicPosition);
					setPrice(auctionPrice);
					setIsLoading(false);
					showToast({
						message: t('activepromo'),
						variant: 'success',
					});

					setOpen(false);
				} else if (res.result === false) {
					showToast({
						message: t('oops'),
						variant: 'error',
					});
				}
			} catch (error) {
				console.error(error)
				showToast({
					message: t('oops'),
					variant: 'error',
				});
			}
		};

		if (minPrice > auctionPrice) {
			setIsLow(true);
		} else {
			fetchData();
		}
	};

	useEffect(() => {
		setIsLow(minPrice > auctionPrice);
	}, [auctionPrice]);

	const isButtonDisabled = () => {
		// console.log(
		// 	'=> disable cause, isLow:',
		// 	isLow,
		// 	'full:',
		// 	!full,
		// 	'&& date:',
		// 	!date,
		// 	'hasChanges:',
		// 	hasChanges
		// );
		return isLow || (!full && !date) || !hasChanges;
	};

	return (
		<>
			<Popup
				id={'connectPromotionAdPopup'}
				open={open}
				setOpen={setOpen}
				isLoading={isLoading}
				container={'div'}
				clazz={'gap-16'}
			>
				<h2>
					{t('promoteadto') + ' '}
					<Link
						target="_blank"
						to={`/profile/${slugProfile}`}
					>
						{name}
					</Link>
				</h2>

				<span className={'color-main text-center p2'}>
					{t('adplace')}
				</span>

				<span className="ver__block__money m-auto event-none">
					{t('minauc')} &mdash; {minPrice}
					<Icon
						title={t('EroCoins')}
						clazz={'color-main'}
						spritePath={'erocoin'}
						size={'xs'}
					/>{' '}
					/ {t('day')}
				</span>

				<div className="connectad">
					<div className={`connectad__day${isLow ? ' low' : ''}`}>
						<span className="p2 color-main">
							{t('dailycharges')}
						</span>

						<InputWithArrows
							onChange={onChangeAuction}
							value={auctionPrice}
							onClickDown={handleClickDown}
							onClickUp={handleClickUp}
						/>

						{/* <span className="p2">{t("paynow")}</span>

            <span className="title_h3 mb-0 text-center">
              {`${
                auctionPrice - currentPrice <= 1 ? 1 : auctionPrice - currentPrice
              }`}{" "}
              <Icon
                title={t("EroCoins")}
                clazz={"color-main"}
                spritePath={"erocoin"}
                size={"s"}
              />
            </span> */}
					</div>

					<p className="color-green title_h2">
						{dynamicPosition}
						{t('th')} {t('position')}
					</p>

					<span
						className={`p2 connectad__error${!isLow ? ' low' : ''}`}
					>
						{t('dailycharges')} {t('minbet')} &mdash;{' '}
						<strong>{minPrice} €</strong>
					</span>

					<span className="p2 color-main">{validNew}</span>
					<div
						className={`connectad__form${full ? ' _empty-date' : ''
							}`}
					>
						<div className="connectad__form__check">
							<Checkbox
								title={t('indefinitely')}
								onClick={onChangeFull}
								checked={full}
							/>
						</div>

						<fieldset
							onClick={() => {
								if (full) setFull(false);
							}}
						>
							<legend>{t('untildate')}</legend>
							<InputInLabel
								type="date"
								disabled={full}
								onChange={onChangeDate}
								value={date || ''} // Add value prop
							></InputInLabel>
						</fieldset>
					</div>
				</div>

				<Button
					size={'l'}
					clazz={'button--green justify-center'}
					disabled={isButtonDisabled()}
					onClick={(e) => onSubmit(e)}
				>
					{t('confirm')}
				</Button>
			</Popup>

			{zeroBalance && (
				<MinBalancePopup
					open={zeroBalance}
					setOpen={setZeroBalance}
				/>
			)}
		</>
	);
};

export default ConnectPromotionAdPopup;
